import { useTranslation } from 'next-i18next'
import bfm from 'assets/press-bfm.webp'
import europe1 from 'assets/press-europe1.webp'
import forbes from 'assets/press-forbes.webp'
import orange from 'assets/press-jdn.webp'
import echos from 'assets/press-les-echos.webp'
import ouest from 'assets/press-ouest.webp'
import Logos from 'blocks/Logos'

const PRESS = [
  {
    image: bfm,
    alt: 'BFM Business logo',
    imageStyle: '',
  },
  {
    image: forbes,
    alt: 'Forbes logo',
    imageStyle: '',
  },
  {
    image: orange,
    alt: 'Orange logo',
    imageStyle: '',
  },
  {
    image: ouest,
    alt: 'Ouest France logo',
    imageStyle: '',
  },
  {
    image: europe1,
    alt: 'Europe 1 logo',
    imageStyle: '',
  },
  {
    image: echos,
    alt: 'Les Echos logo',
    imageStyle: '',
  },
]

export function Press() {
  const { t } = useTranslation('home.page')

  return (
    <Logos
      images={PRESS}
      title={t('press.title')}
      link={{
        url: 'https://dift.notion.site/Espace-presse-Captain-Cause-65c0131ddc3744b39d72e516b936ed27',
        title: t('press.link.title'),
      }}
    />
  )
}
